import type { IVariantProps } from './index';

import { css } from 'styled-components';

import theme from '$/assets/theme';

const autoCompleteAnswer = (props: IVariantProps) => ({
  button: css`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 12px 20px;
    background: ${theme.colors.grey1};
    border: 1px solid ${theme.colors.grey1};
    outline: none;
    cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;

    &:focus {
      border: 1px solid ${theme.colors.grey4};
    }

    ${props.selected &&
    css`
      border-color: ${(props) => props.theme.colors.brandGreen};
      background: ${(props) => props.theme.colors.white};
    `}
  `,
  text: css`
    font-size: 18px;
    font-weight: normal;
    color: ${props.disabled ? theme.colors.grey3 : theme.colors.grey7};
  `,
  iconContainer: css`
    position: absolute;
    left: -11px;
    margin: 0;
  `,
});

export default autoCompleteAnswer;
